import {
  ACCEPT_AND_PUBLISH_SELLER_QUOTE_BID,
  ACCEPT_AND_PUBLISH_SELLER_QUOTE_BID_ERROR,
  ACCEPT_AND_PUBLISH_SELLER_QUOTE_BID_SUCCESS,
  CLOSE_SEND_SELLER_QUOTE_DIALOG,
  SHOW_SEND_SELLER_QUOTE_DIALOG,
  HIDE_ERRORS_SEND_SELLER_QUOTE_DIALOG_SUCCESS
} from './SendSellerQuoteDialog.actions'

const sendSellerQuoteDialogState = {
  comprobanteEnvio: null,
  error: false,
  loading: false,
  open: false,
  showAbilityAffidavit: false,
  success: '',
  errors: []
}

/**
 * The sendSellerQuoteDialog's reducer.
 */
const sendSellerQuoteDialogReducer = (state = sendSellerQuoteDialogState, { payload, type }) => {
  switch (type) {
    case ACCEPT_AND_PUBLISH_SELLER_QUOTE_BID: {
      return { ...state, error: false, loading: true }
    }
    case ACCEPT_AND_PUBLISH_SELLER_QUOTE_BID_ERROR: {
      return {
        ...state,
        error: true,
        loading: false,
        errors: payload.error
      }
    }
    case ACCEPT_AND_PUBLISH_SELLER_QUOTE_BID_SUCCESS: {
      return {
        ...state,
        comprobanteEnvio: payload.payload || null,
        loading: false,
        success: payload.success,
        errors: []
      }
    }
    case CLOSE_SEND_SELLER_QUOTE_DIALOG: {
      return { ...state, open: false }
    }
    case SHOW_SEND_SELLER_QUOTE_DIALOG: {
      return { ...state, error: false, open: true, showAbilityAffidavit: payload.showAbilityAffidavit }
    }
    case HIDE_ERRORS_SEND_SELLER_QUOTE_DIALOG_SUCCESS: {
      return {
        ...state,
        errors: [],
        error: false
      }
    }
    default: {
      return state
    }
  }
}

export default sendSellerQuoteDialogReducer
